// Autogenerated file
export const assistantChatReportTypesEnum = {
    EveryWeekStatistic: "EveryWeekStatistic",
    InvolvementAnalysis: "InvolvementAnalysis",
    MonthResult: "MonthResult",
    EveryWeekRefuelingStatistic: "EveryWeekRefuelingStatistic",
};
export const assistantChatReportTypes = [
    { label: "Динамика изменения ключевых показателей парка", value: "EveryWeekStatistic" },
    { label: "Отчет по анализу вовлеченности и эффективности", value: "InvolvementAnalysis" },
    { label: "Отчет по итогам месяца", value: "MonthResult" },
    { label: "Еженедельный отчет по заправкам", value: "EveryWeekRefuelingStatistic" },
];
